import api from '../token';

export const ListImposto = async () => {
  try {
    const response = await api.post('/getImposto');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

